import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AccidentReportProvider } from './reducer/accident-report/accident-report.reducer';
import { BaseProvider } from './reducer/base/base.reducer';
import "./scss/base.scss";
import { SickReportProvider } from './reducer/sick-report/sick-report.reducer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <BaseProvider>
                <AccidentReportProvider>
                    <SickReportProvider>
                        <App />
                    </SickReportProvider>
                </AccidentReportProvider>
            </BaseProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
